// Módulos
import { Component, OnInit, ViewChild } from '@angular/core';

// Interfaces y Modelos
import { IAlmacen } from 'src/app/interfaces/almacenes';
import { IUbicacion, IUbiTipo } from 'src/app/interfaces/ubicacion';
import { IListaOpciones } from 'src/app/interfaces/lista-opciones';

// Servicios
import { AlmacenesService } from 'src/app/services/datos/almacenes.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';
import { UbicacionesService } from './../../../services/datos/ubicaciones.service';

// Librerías
import { ColumnMode } from '@swimlane/ngx-datatable';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import FuncLib from 'src/app/providers/funcionesLib';

@Component({
  selector: 'app-ubicaciones',
  templateUrl: './ubicaciones.component.html',
  styleUrls: ['./ubicaciones.component.scss']
})
export class UbicacionesComponent implements OnInit {

  public funcLib: FuncLib = new FuncLib();

  public lista: IUbicacion[] = [];
  almacenesList: IAlmacen[] = [];
  public pasillosOcupadosApi: any = {};

  public rows: any = [];
  public temp: any[] = [];

  // Propiedades para el filtrado por pasillo
  public ubicacionesOriginales: IUbicacion[] = [];
  public ubicacionesFiltradas: IUbicacion[] = [];

  public rowsLimitStr: string = localStorage.getItem('linTablas') || '10';
  public rowsLimit: number = parseInt(this.rowsLimitStr);

  textoDestacado: string = '';
  public loading: boolean = false;

  almSeleccionado: string = this.usuarioSrv.userdata.alm_por_defecto || '0';    // Almacén por defecto
  pasilloSeleccionado: string = '0'; // Pasillo seleccionado ('0' = todos)
  public pasillosList: string[] = [];
  public collapseEstadisticas: boolean = true;

  messages = {
    emptyMessage: `<span class="text-danger">Sin datos...</span>`,
    totalMessage: 'Total',
    selectedMessage: 'seleccionado'
  }

  ColumnMode = ColumnMode;
  @ViewChild(UbicacionesComponent) table: UbicacionesComponent | any;

  constructor(
    private ubiSrv: UbicacionesService,
    private notificacionesSrv: NotificacionesService,
    private usuarioSrv: UsuarioService,
    private almacenSrv: AlmacenesService
  ) { }

  ngOnInit(): void {
    this.inicializarPasillos();
    this.getAlmacenes();
    this.cargaLista();
  }

  // cargaLista() {
  //   const opcionesList: IListaOpciones = {}
  //   opcionesList.id_almacen = parseInt(this.almSeleccionado);
  //   this.loading = true;
  //   this.ubiSrv.getListaFiltrada(opcionesList)
  //     .subscribe(resp => {
  //       this.loading = false;

  //       console.log('__cargaLista() opcionesList', opcionesList);
  //       console.log('__cargaLista() resp', resp);

  //       this.lista = resp.data;
  //       this.pasillosList = resp.totales.pasillosList;

  //       // Guardar copia original para filtros
  //       this.ubicacionesOriginales = [...this.lista];

  //       // Aplicar filtro de pasillo si hay uno seleccionado
  //       this.aplicarFiltroPasillo();
  //     })
  // }

  cargaLista() {
    const opcionesList: IListaOpciones = {};
    opcionesList.id_almacen = parseInt(this.almSeleccionado);
    this.loading = true;

    this.ubiSrv.getListaFiltrada(opcionesList)
      .subscribe(resp => {
        this.loading = false;

        console.log('__cargaLista() opcionesList', opcionesList);
        console.log('__cargaLista() resp', resp);

        this.lista = resp.data;
        this.pasillosList = resp.totales.pasillosList;

        // Guardar copia original para filtros
        this.ubicacionesOriginales = [...this.lista];

        // Guardar también pasillos ocupados de la API
        this.pasillosOcupadosApi = resp.totales.pasillosOcupados || {};

        // Aplicar filtro de pasillo si hay uno seleccionado
        this.aplicarFiltroPasillo();
      });
  }



  /**
   * Aplica el filtro de pasillo actual a los datos cargados
   */
  aplicarFiltroPasillo(): void {
    if (this.pasilloSeleccionado === '0') {
      this.ubicacionesFiltradas = [...this.ubicacionesOriginales];
    } else {
      this.ubicacionesFiltradas = this.filtrarPorPasillo(this.pasilloSeleccionado);
    }

    // Actualizar rows y temp para la tabla
    this.rows = this.ubicacionesFiltradas;
    this.temp = [...this.ubicacionesFiltradas];
  }

  getAlmacenes() {
    this.almacenSrv.getLista()
      .subscribe(respuesta => {
        this.almacenesList = respuesta.data;
      })
  }

  /**
   *  Inicializa pasillosList del '00' al '99'
   */
  inicializarPasillos(): void {
    this.pasillosList = [];
    for (let i = 0; i <= 99; i++) {
      this.pasillosList.push(i.toString().padStart(2, '0'));
    }
  }

  /**
   * Filtrar por pasillo seleccionado
   * Se ejecuta cuando cambia la selección del select
   */
  onPasilloSelect(pasilloSeleccionado: string): void {
    console.log('Pasillo seleccionado:', pasilloSeleccionado);

    this.pasilloSeleccionado = pasilloSeleccionado;
    this.aplicarFiltroPasillo();

    console.log('Ubicaciones filtradas:', this.ubicacionesFiltradas.length);
  }

  /**
   * Filtra las ubicaciones por pasillo
   * @param pasillo Código del pasillo (ej: '00', '01', etc.)
   * @returns Array de ubicaciones filtradas
   */
  filtrarPorPasillo(pasillo: string): IUbicacion[] {
    return this.ubicacionesOriginales.filter(ubicacion => {
      // Extraer pasillo del código (posiciones 3 y 4, índices 2 y 3)
      if (ubicacion.codigo && ubicacion.codigo.length >= 4) {
        const pasilloUbicacion = ubicacion.codigo.substring(2, 4);
        return pasilloUbicacion === pasillo;
      }
      return false;
    });
  }

  /**
   * Obtiene el pasillo de una ubicación específica
   * @param codigo Código de ubicación
   * @returns Código del pasillo o null si no es válido
   */
  obtenerPasilloDeCodigo(codigo: string): string | null {
    if (codigo && codigo.length >= 4) {
      return codigo.substring(2, 4);
    }
    return null;
  }

  //  CRUD  // 

  deleteRow(row: any) {
    const formattedCodigo = row.codigo.replace(/(\d{2})(\d{2})(\d{3})(\d{2})(\d{2})\d$/, '$1.$2.$3.$4.$5');

    Swal.fire({
      title: '¿Borrar ubicación?',
      icon: 'question',
      html: `Eliminar <b>${formattedCodigo}</b>`,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si',
    }).then((result) => {
      if (result.isConfirmed) {
        this.ubiSrv.delete(row.id)
          .subscribe(resp => {
            if (resp.error) {
              this.notificacionesSrv.aviso('error', resp.mensaje);
            } else {
              this.notificacionesSrv.aviso('info', `Registro eliminado`);

              // Actualizar todas las listas después del borrado
              this.ubicacionesOriginales = this.ubicacionesOriginales.filter((objeto: any) => objeto.id !== row.id);
              this.ubicacionesFiltradas = this.ubicacionesFiltradas.filter((objeto: any) => objeto.id !== row.id);
              this.rows = this.rows.filter((objeto: any) => objeto.id !== row.id);
              this.temp = this.temp.filter((objeto: any) => objeto.id !== row.id);
            }
          })
      }
    })
  }

  rowsLimitChange() {
    this.rowsLimit = parseInt(this.rowsLimitStr); // convertir el valor a número
  }

  buscarTodo(event: any) {
    const txt = event?.target?.value?.toLowerCase() ?? '';

    // Buscar solo en las ubicaciones filtradas por pasillo
    const temp = this.ubicacionesFiltradas.filter((d: any) =>
      Object.keys(d).some((key: any) =>
        d[key] && d[key].toString().toLowerCase().includes(txt.toLowerCase())
      )
    );

    this.textoDestacado = txt;
    this.rows = temp;
    this.table = this.lista;
  }

  // EXPORTAR A EXCEL
  exportToExcel(): void {
    const fileName = `Ubicaciones-${new Date().toISOString()}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(this.rows);
    const workbook = XLSX.utils.book_new();

    // Forzar valores numéricos en las columnas Xlsx
    Object.entries(worksheet).forEach(([cell, cellObj]) => {
      if (!cell.startsWith('!') && !isNaN(cellObj.v) && cellObj.v !== '') {
        cellObj.v = Number(cellObj.v);
        cellObj.t = 'n';
      }
    });

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, fileName);
  }

  onAlmacenSelect(id: string) {
    this.almSeleccionado = id;
    this.pasilloSeleccionado = '0'; // Reset pasillo filter when changing almacen
    this.cargaLista();
  }

  /**
   * Obtiene estadísticas por pasillo
   * @returns Object con conteo por pasillo
   */
  // obtenerEstadisticasPorPasillo(): { [key: string]: number } {
  //   const estadisticas: { [key: string]: number } = {};

  //   this.ubicacionesOriginales.forEach(ubicacion => {
  //     if (typeof ubicacion.codigo === 'string') {
  //       const pasillo = this.obtenerPasilloDeCodigo(ubicacion.codigo);
  //       if (pasillo) {
  //         estadisticas[pasillo] = (estadisticas[pasillo] || 0) + 1;
  //       }
  //     }
  //   });

  //   return estadisticas;
  // }



  obtenerEstadisticasPorPasillo(): { [key: string]: { ocupadas: number, total: number, porcentaje: number } } {
    const estadisticas: { [key: string]: { ocupadas: number, total: number, porcentaje: number } } = {};

    if (!this.pasillosOcupadosApi) {
      return estadisticas;
    }

    Object.keys(this.pasillosOcupadosApi).forEach(pasillo => {
      const info = this.pasillosOcupadosApi[pasillo];
      estadisticas[pasillo] = {
        ocupadas: info.ocupadas || 0,
        total: info.total || 0,
        porcentaje: info.porcentaje || 0
      };
    });

    return estadisticas;
  }


  /**
   * Obtiene solo los pasillos que tienen ubicaciones en el almacén actual
   * @returns Array de pasillos únicos que existen en los datos
   */
  obtenerPasillosConDatos(): string[] {
    const pasillosUnicos = new Set<string>();

    this.ubicacionesOriginales.forEach(ubicacion => {
      if (typeof ubicacion.codigo === 'string') {
        const pasillo = this.obtenerPasilloDeCodigo(ubicacion.codigo);
        if (pasillo) {
          pasillosUnicos.add(pasillo);
        }
      }
    });

    return Array.from(pasillosUnicos).sort();
  }
}